import getUrlSearch from './getUrlSearch';

const shopId = window.AVADA_APP_FAQS_STATUS?.shopId;

const CLIENT_API = `https://${process.env.API_URL}/client/api`;

function trackUseSendBeacon(url, objData) {
  const payload = objData ? JSON.stringify(objData) : undefined;
  if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
    try {
      navigator.sendBeacon(url, payload);
      return;
    } catch (_) {
      // fallback to fetch
    }
  }
  fetch(url, {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: payload
  }).catch(() => {});
}

export async function trackCampaignShow(campaignId) {
  if (!shopId || !campaignId) return;
  const url = `${CLIENT_API}/campaigns/track-show?${getUrlSearch({shopId, campaignId})}`;
  trackUseSendBeacon(url);
}

export function trackCampaignClick(campaignId) {
  if (!shopId || !campaignId) return;
  const url = `${CLIENT_API}/campaigns/track-click?${getUrlSearch({shopId, campaignId})}`;
  trackUseSendBeacon(url);
}
